import { lookupGetStateOld } from 'legacy/lut/store'
import { useMemo } from 'react'

import { Static } from 'core-components/types'
import { Crud } from 'core/types/Crud'

export const languagesBP = [
  { id: 'en', value: 'English' },
  { id: 'cs', value: 'Czech' },
  { id: 'da', value: 'Danish' },
  { id: 'de', value: 'German' },
  { id: 'el', value: 'Greek' },
  { id: 'es', value: 'Spanish' },
  { id: 'fi', value: 'Finnish' },
  { id: 'fr', value: 'French' },
  { id: 'he', value: 'Hebrew' },
  { id: 'hr', value: 'Croatian' },
  { id: 'hu', value: 'Hungarian' },
  { id: 'it', value: 'Italian' },
  { id: 'nl', value: 'Dutch' },
  { id: 'no', value: 'Norwegian' },
  { id: 'pl', value: 'Polish' },
  { id: 'pt', value: 'Portuguese' },
  { id: 'ro', value: 'Romanian' },
  { id: 'ru', value: 'Russian' },
  { id: 'sv', value: 'Swedish' },
  { id: 'sk', value: 'Slovak' },
  { id: 'tr', value: 'Turkish' },
  { id: 'et', value: 'Estonian' },
  { id: 'lt', value: 'Lithuanian' },
  { id: 'lv', value: 'Latvian' },
]

const languagesBPSet = new Set(languagesBP.map((el) => el.value))

export const useReferenceData = () => {
  const langSource = useMemo(() => {
    return new Crud({
      fetcher: new Static([
        ...lookupGetStateOld().references.languages.filter(
          (item: { name: string; value: string }) => languagesBPSet.has(item.name)
        ),
      ]),
      keyField: 'value',
      defaultPaging: {
        page: 0,
        pageSize: 100,
      },
    })
  }, [lookupGetStateOld().references.languages])

  return { langSource }
}
